import { useCallback } from 'react'

import { Button, Toggle } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { ModalBackButton } from '@containers/layout'
import { routes } from '@services/sections/modal/routes'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

import { useWalletApprovalPolicy } from '../../../../hooks/approval-policy'
import { WalletApprovalPolicyStep } from '../../../../hooks/approval-policy/context'
import { WalletApprovalPolicyLayout } from '../../../../layout'

export const TransferType: React.FC = () => {
  const { t } = useTranslation('modals.walletApprovalPolicy')
  const { router } = useModal()
  const [{ settings }, { setPolicySettings }] = useWalletApprovalPolicy()

  const handleToggleChange = useCallback(
    (selected: boolean) => {
      setPolicySettings({
        applyToApi: selected,
      })
    },
    [setPolicySettings],
  )

  const handleContinue = useCallback(() => {
    router.push(routes.walletApprovalPolicy.createPolicy.review)
  }, [router])

  return (
    <WalletApprovalPolicyLayout
      currentStep={WalletApprovalPolicyStep.TRANSFER_TYPE}
    >
      <div className="grid max-w-168 grid-cols-1 justify-items-start">
        <h2 className="text-neutral-strong type-h-page-sm">
          {t('transferType.title')}
        </h2>

        <p className="mt-4 text-neutral-strong type-intro-sm">
          <Trans
            components={{ b: <b /> }}
            i18nKey="modals.walletApprovalPolicy:transferType.description"
          />
        </p>

        <div className="mt-10 flex w-full items-center justify-between">
          <span className="text-neutral type-body-base">
            <Trans
              components={{ b: <b /> }}
              i18nKey="modals.walletApprovalPolicy:transferType.turnOnApiTransfers"
            />
          </span>

          <Toggle
            onChange={handleToggleChange}
            selected={settings?.applyToApi ?? false}
            size="sm"
          />
        </div>

        <div className="mt-10">
          <ModalBackButton />

          <Button className="w-60" onClick={handleContinue} variant="primary">
            {t('common:continue')}
          </Button>
        </div>
      </div>
    </WalletApprovalPolicyLayout>
  )
}
